import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUsersByOrganizationIdsQueryVariables = Types.Exact<{
  organization_ids?: Types.InputMaybe<Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input']>;
}>;


export type GetUsersByOrganizationIdsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, first_name: string, last_name: string, email: string, phone_number?: string | null, profile_photo?: string | null, created_at?: any | null, last_seen?: any | null, is_admin?: boolean | null, role?: string | null, title?: string | null, workspace_id?: any | null, organization_id?: any | null, workspace?: { __typename?: 'workspaces', id: any, logo?: string | null, name: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null, user_properties: Array<{ __typename?: 'user_properties', id: any, user_id: string, property_id: any, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null } | null }>, user_organizations: Array<{ __typename?: 'organizations_users', id: any, organization_id: any, user_id: string, created_at?: any | null, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null }> }> };


export const GetUsersByOrganizationIdsDocument = gql`
    query getUsersByOrganizationIds($organization_ids: [uuid!]) {
  users(
    where: {organization_id: {_in: $organization_ids}, deleted_at: {_is_null: true}}
    order_by: {first_name: asc}
  ) {
    id
    first_name
    last_name
    email
    phone_number
    profile_photo
    created_at
    last_seen
    is_admin
    role
    title
    workspace_id
    workspace {
      id
      logo
      name
    }
    organization_id
    organization {
      id
      name
      type
      organizationImageURL
    }
    user_properties {
      id
      user_id
      property_id
      property {
        id
        name
        address
        address_id
        standardized_address {
          id
          street_1
          street_2
          city
          state
          postal_code
          country
        }
        organization {
          id
          name
          type
          organizationImageURL
        }
      }
    }
    user_organizations {
      id
      organization_id
      user_id
      created_at
      organization {
        id
        name
        type
        organizationImageURL
      }
    }
  }
}
    `;

/**
 * __useGetUsersByOrganizationIdsQuery__
 *
 * To run a query within a React component, call `useGetUsersByOrganizationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByOrganizationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByOrganizationIdsQuery({
 *   variables: {
 *      organization_ids: // value for 'organization_ids'
 *   },
 * });
 */
export function useGetUsersByOrganizationIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersByOrganizationIdsQuery, GetUsersByOrganizationIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByOrganizationIdsQuery, GetUsersByOrganizationIdsQueryVariables>(GetUsersByOrganizationIdsDocument, options);
      }
export function useGetUsersByOrganizationIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByOrganizationIdsQuery, GetUsersByOrganizationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByOrganizationIdsQuery, GetUsersByOrganizationIdsQueryVariables>(GetUsersByOrganizationIdsDocument, options);
        }
export function useGetUsersByOrganizationIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersByOrganizationIdsQuery, GetUsersByOrganizationIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersByOrganizationIdsQuery, GetUsersByOrganizationIdsQueryVariables>(GetUsersByOrganizationIdsDocument, options);
        }
export type GetUsersByOrganizationIdsQueryHookResult = ReturnType<typeof useGetUsersByOrganizationIdsQuery>;
export type GetUsersByOrganizationIdsLazyQueryHookResult = ReturnType<typeof useGetUsersByOrganizationIdsLazyQuery>;
export type GetUsersByOrganizationIdsSuspenseQueryHookResult = ReturnType<typeof useGetUsersByOrganizationIdsSuspenseQuery>;
export type GetUsersByOrganizationIdsQueryResult = Apollo.QueryResult<GetUsersByOrganizationIdsQuery, GetUsersByOrganizationIdsQueryVariables>;